'use client'
import Cookies from 'js-cookie'

export const updateCookie = (
  cookieKey: string,
  data: Record<string, any>,
  options?: Cookies.CookieAttributes
) => {
  const current = Cookies.get(cookieKey)

  let parsed = {}

  try {
    parsed = current ? JSON.parse(current) : {}
  } catch {
    parsed = {}
  }

  const updated = {
    ...parsed,
    ...data,
  }

  Cookies.set(cookieKey, JSON.stringify(updated), {
    path: '/',
    sameSite: 'lax',
    secure: process.env.NODE_ENV === 'production',
    ...options,
  })
}

export const removeCookie = (cookieKey: string) => {
  Cookies.remove(cookieKey, { path: '/' })
}

export const getJsonCookie = <T = any>(cookieKey: string): T | null => {
  const value = Cookies.get(cookieKey)
  if (!value) return null

  try {
    return JSON.parse(value) as T
  } catch {
    return null
  }
}
